<script>
import MetroAreaResource from '@/resources/metroarea'

export default {
    components: {},
    props: {
        value: {
            type: [Array, MetroAreaResource],
            default() {
                return []
            }
        },
        single: Boolean
    },
    data() {
        return {
            loading: true,
            metroAreaResources: [],
            metroAreaResourcesSelected: [],
            metroAreasSorted: {}
        }
    },
    watch: {
        metroAreaResourcesSelected() {
            this.$emit('input', this.metroAreaResourcesSelected)
        },
        value(value) {
            this.metroAreaResourcesSelected = value
        }
    },
    methods: {
        metroRegionToKey(region) {
            return region.replace(/[\W_]+/g, '')
        },
    },
    async mounted() {
        this.metroAreaResources = await MetroAreaResource.all()
        this.metroAreaResourcesSelected = this.value

        for (let metroKey in this.metroAreaResources) {
            let metroAreaResource = this.metroAreaResources[metroKey]
            let region = metroAreaResource.get('region')
            if (!this.metroAreasSorted[region]) {
                this.metroAreasSorted[region] = []
            }

            this.metroAreasSorted[region].push(metroAreaResource)
        }

        this.loading = false
    },
}
</script>

<template>
    <div>
        <!-- Single select -->
        <b-form-select v-if="single" v-model="metroAreaResourcesSelected">
            <b-form-select-option :value="[]">Please Select a Region</b-form-select-option>
            <b-form-select-option-group v-for="(metros, region) in metroAreasSorted" :key="metroRegionToKey(region)" :label="region">
                <b-form-select-option v-for="(metro, i) in metros" :key="i" :value="metro" :label="String(metro)" />
            </b-form-select-option-group>
        </b-form-select>

        <!-- Multi select -->
        <b-card v-else no-body class="mb-4">
            <b-tabs pills card vertical v-if="!loading">
                <b-tab v-for="(metros, region) in metroAreasSorted" :key="metroRegionToKey(region)" :title="region">
                    <b-card-text>
                        <ul class="list-unstyled pl-3 location-list">
                            <li v-for="(metro, i) in metros" :key="i">
                                <b-form-checkbox v-model="metroAreaResourcesSelected" :value="metro">{{ metro }}</b-form-checkbox>
                            </li>
                        </ul>
                    </b-card-text>
                </b-tab>
            </b-tabs>

            <slot name="loading" v-else>
                <p>Loading...</p>
            </slot>
        </b-card>
    </div>
</template>

<style lang="scss">
</style>
